import React, { useContext, useState, useRef } from "react";
import {
  // IconButton,
  // Paper,
  // ClickAwayListener,
  // Popper,
  // Grow,
  // FormControl,
  // RadioGroup,
  // Radio,
  // FormControlLabel,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext, changeLang } from "../../Context/Langcontext";
// import { MdTranslate } from "react-icons/md";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "fit-content",
    paddingRight: "2rem",
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  font: {
    color: "black",
    fontWeight: 700,
    margin: 2,
    cursor: "pointer",
  },
  divider: {
    backgroundColor: "black",
    height: "50%",
  },
  fontun: {
    color: "black",
    fontWeight: 200,
    margin: 2,
    cursor: "pointer",
  },
  cardStyle: {
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    width: "100%",
  },
  label: {
    "& .MuiFormControlLabel-label": {
      fontWeight: 200,
    },
  },
  fontStyle: {
    color: "#595a5a",
    fontWeight: 200,
    cursor: "pointer",
  },
  fontActive: {
    color: "#595a5a",
    fontWeight: 700,
    cursor: "pointer",
  },
  fontmiddle: {
    color: "#595a5a",
    fontWeight: 400,
    marginLeft: 5,
    marginRight: 5,
  },
}));
const ChangeLanguage = () => {
  const classes = useStyles();
  const langContext = useContext(LangContext);
  const [open] = useState(false);
  const anchorRef = useRef(null);
  const { langDispatch } = langContext;

  // const handleChange = (event) => {
  //   setValue(event.target.value);
  //   langDispatch(changeLang(event.target.value));
  // };
  // const ChangeLangu = (lang) => {
  //   if (lang === "TH") {
  //     langDispatch(changeLang("en"));
  //   } else {
  //     langDispatch(changeLang("th"));
  //   }
  // };

  // const handleClose = (event) => {
  //   if (anchorRef.current && anchorRef.current.contains(event.target)) {
  //     return;
  //   }

  //   setOpen(false);
  // };

  // const LanguageListItem = () => {
  //   return (
  //     <Paper className={classes.cardStyle}>
  //       <ClickAwayListener onClickAway={handleClose}>
  //         <FormControl component="fieldset" style={{ margin: "1rem" }}>
  //           <RadioGroup
  //             aria-label="gender"
  //             name="language"
  //             value={value}
  //             onChange={handleChange}
  //           >
  //             <FormControlLabel
  //               value="en"
  //               control={<Radio color="primary" />}
  //               label="English"
  //               className={classes.label}
  //             />
  //             <FormControlLabel
  //               value="th"
  //               control={<Radio color="primary" />}
  //               label="ภาษาไทย"
  //               className={classes.label}
  //             />
  //           </RadioGroup>
  //         </FormControl>
  //       </ClickAwayListener>
  //     </Paper>
  //   );
  // };

  // const handleToggle = () => {
  //   setOpen((prevOpen) => !prevOpen);
  // };
  const prevOpen = useRef(open);

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    // <Grid container alignItems="center" className={classes.root}>
    <div className={classes.root}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography
          className={
            langContext.lang.locale === "th"
              ? classes.fontStyle
              : classes.fontActive
          }
          onClick={() => {
            langDispatch(changeLang("en"));
          }}
        >
          EN
        </Typography>
        <Typography className={classes.fontmiddle}>|</Typography>
        <Typography
          className={
            langContext.lang.locale === "th"
              ? classes.fontActive
              : classes.fontStyle
          }
          onClick={() => {
            langDispatch(changeLang("th"));
          }}
        >
          TH
        </Typography>
      </div>
      {/* <IconButton onClick={handleToggle} ref={anchorRef}>
        <MdTranslate size={20} />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-end"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <LanguageListItem />
          </Grow>
        )}
      </Popper> */}
    </div>
  );
};

export default ChangeLanguage;
